module.exports = __webpack_public_path__ + "static/img/28.61ac2235.jpg";